@if (showHeading() && hasApprovedVehicle()) {
  <onyx-information-heading>
    @if (vehicle()) {
      {{
        (trailer() || hasLoadedSemiTrailer()
          ? 'labels.vehicles'
          : 'labels.vehicle'
        ) | translate
      }}
    } @else {
      {{ 'labels.missingVehicle' | translate }}
    }

    @if (order().relatedFleetSwap?.identifier; as identifier) {
      <span subheading>
        {{ `${I18N}.plannedSwap` | translate }}

        <onyx-link color="gray" (click)="openSwapModal()">
          {{ identifier }}
        </onyx-link>
      </span>
    }

    @if (planChangeButton(); as button) {
      <onyx-icon-button
        actions
        variant="transparent"
        color="gray"
        [size]="32"
        icon="exchange-filled"
        [circle]="true"
        [disabled]="button.disabled"
        [onyxTooltip]="button.tooltip"
        (click)="planChange()"
      ></onyx-icon-button>
    }

    <onyx-icon-button
      actions
      color="gray"
      variant="transparent"
      [size]="32"
      icon="history-outlined"
      [circle]="true"
      onyxTooltip="labels.vehicleAndDriverHistory"
      (click)="openActivityModal()"
    ></onyx-icon-button>
  </onyx-information-heading>
}
@if (isSectionVisible()) {
  <div class="vehicles">
    @let assignmentType = missingAssignment()?.type;
    @let hasUnassignedVehicle =
      assignmentType
        ? [
            OrderMissingAssignmentType.GOODS_WITHOUT_VEHICLE,
            OrderMissingAssignmentType.LOADED_TRAILER_WITHOUT_VEHICLE,
          ].includes(assignmentType)
        : false;
    <onyx-data-widget
      [headingIcon]="
        vehicle()
          ? {
              name: `${vehicle()!.generalInformation.category}-filled`,
              size: 20,
              color: 'black',
            }
          : hasUnassignedVehicle
            ? {
                name: 'vehicle-disconnected-filled',
                size: 20,
                color: 'red',
              }
            : null
      "
      [showDivider]="
        (!!vehicle() &&
          !hasApprovedVehicle() &&
          !!vehicleParameters().length) ||
        hasUnassignedVehicle
      "
      [color]="isVehicleInvalid() ? 'yellow' : 'gray'"
      [clickable]="!!vehicle() && fleetHelper.hasModule()"
      (click)="
        vehicle() && fleetHelper.hasModule() ? openFleetModal(vehicle()!) : null
      "
    >
      <ng-container heading>
        @let showAlertIcon =
          hasApprovedVehicle() && vehicleInvalidParameters().length;
        @if (vehicle() || showAlertIcon) {
          <div class="heading-wrapper">
            @if (vehicle(); as vehicle) {
              {{ vehicle | fleetIdentifier }}
            }

            @if (showAlertIcon) {
              <onyx-icon
                name="alert-two-tone-filled"
                [size]="20"
                [onyxTooltip]="vehicleParametersTemplate"
                [onyxTooltipTemplateContext]="{
                  showOnlyInvalid: true,
                  color: isVehicleInvalid() ? 'yellow' : 'gray',
                }"
                onyxTooltipColor="white"
              ></onyx-icon>
            }
          </div>
        } @else if (hasUnassignedVehicle) {
          @let categories = searchingVehicleData().categories;
          @if (categories.length === 1) {
            @let category = categories[0];
            {{ `${I18N}.missing.${category}` | translate }}
          } @else {
            {{ 'labels.missingVehicle' | translate }}
          }
        }
      </ng-container>

      <ng-container description>
        @if (vehicle(); as vehicle) {
          <app-fleet-description-parameters
            [fleet]="vehicle"
            [isCell]="false"
          ></app-fleet-description-parameters>
        }
      </ng-container>

      @if (!hasApprovedVehicle()) {
        <ng-container
          *ngTemplateOutlet="
            vehicleParametersTemplate;
            context: {
              color: isVehicleInvalid() ? 'yellow' : 'gray',
            }
          "
        ></ng-container>
      }
    </onyx-data-widget>

    @let basicInformation = order().basicInformation;
    @let loadedSemiTrailerRegistrationNumber =
      basicInformation?.loadedSemiTrailer.registrationNumber;
    @let loadedSemiTrailer = basicInformation?.loadedSemiTrailer.data;

    @if (hasLoadedSemiTrailer()) {
      <onyx-data-widget
        [headingIcon]="{
          name: 'semi-trailer-loaded-filled',
          size: 20,
          color: loadedSemiTrailer ? 'black' : 'sea-green',
        }"
        [clickable]="!!loadedSemiTrailer && fleetHelper.hasModule()"
        (click)="
          loadedSemiTrailer && fleetHelper.hasModule()
            ? openFleetModal(loadedSemiTrailer)
            : null
        "
      >
        <ng-container heading>
          {{
            loadedSemiTrailerRegistrationNumber ??
              (loadedSemiTrailer | fleetIdentifier)
          }}
        </ng-container>

        <ng-container description>
          <span class="f-muted">
            {{
              `labels.${loadedSemiTrailer ? 'loadedSemiTrailerPickup' : 'loadedForeignTrailer'}`
                | translate
            }}
            ·
            @for (type of basicInformation.vehicleTypes; track type) {
              {{ `${DictionaryCode.VEHICLE_TYPE}.${type}` | translate }}<!---->
              @if (!$last) {
                @if ($index === basicInformation.vehicleTypes.length - 2) {
                  {{ 'labels.or' | translate }}
                } @else {
                  <!---->,
                }
              }
            }
            ·
            {{
              `${DictionaryCode.ORDER_SEMI_TRAILER_SIZE}.${basicInformation.minSemiTrailerSize}`
                | translate
            }}
          </span>
        </ng-container>
      </onyx-data-widget>
    } @else if (
      searchingTrailerTypes() &&
      (searchingVehicleData().isLowDeck || !!trailer())
    ) {
      @let hasUnassignedTrailer =
        missingAssignment()?.type ===
        OrderMissingAssignmentType.GOODS_WITHOUT_VEHICLE;
      <onyx-data-widget
        [headingIcon]="
          trailer()
            ? {
                name: `${trailer()!.generalInformation.category}-filled`,
                size: 20,
                color: 'black',
              }
            : hasUnassignedTrailer
              ? {
                  name: 'vehicle-disconnected-filled',
                  size: 20,
                  color: 'red',
                }
              : null
        "
        [showDivider]="
          (!!trailer() && !hasApprovedVehicle()) || hasUnassignedTrailer
        "
        [color]="isTrailerInvalid() ? 'yellow' : 'gray'"
        [clickable]="!!trailer() && fleetHelper.hasModule()"
        (click)="
          trailer() && fleetHelper.hasModule()
            ? openFleetModal(trailer()!)
            : null
        "
      >
        <ng-container heading>
          @let showAlertIcon =
            hasApprovedVehicle() && trailerInvalidParameters().length;
          @if (trailer() || showAlertIcon) {
            <div class="heading-wrapper">
              @if (trailer(); as trailer) {
                {{ trailer | fleetIdentifier }}
              }

              @if (showAlertIcon) {
                <onyx-icon
                  name="alert-two-tone-filled"
                  [size]="20"
                  [onyxTooltip]="trailerParametersTemplate"
                  [onyxTooltipTemplateContext]="{
                    showOnlyInvalid: true,
                    color: isTrailerInvalid() ? 'yellow' : 'gray',
                  }"
                  onyxTooltipColor="white"
                ></onyx-icon>
              }
            </div>
          } @else if (hasUnassignedTrailer) {
            {{
              `${I18N}.missing.${searchingVehicleData().isLowDeck ? FleetCategory.SEMI_TRAILER : FleetCategory.TRAILER}`
                | translate
            }}
          }
        </ng-container>

        <ng-container description>
          @if (trailer(); as trailer) {
            <app-fleet-description-parameters
              [fleet]="trailer"
              [isCell]="false"
            ></app-fleet-description-parameters>
          }
        </ng-container>

        @if (!hasApprovedVehicle()) {
          <ng-container
            *ngTemplateOutlet="
              trailerParametersTemplate;
              context: {
                color: isTrailerInvalid() ? 'yellow' : 'gray',
              }
            "
          ></ng-container>
        }
      </onyx-data-widget>
    } @else if (hasApprovedVehicle()) {
      <onyx-data-widget>
        <div class="center-section">
          {{
            `labels.${vehicle()?.generalInformation?.category === FleetCategory.SEMI_TRUCK ? 'noSemiTrailer' : 'noTrailer'}`
              | translate
          }}
        </div>
      </onyx-data-widget>
    }

    @if (!hasApprovedVehicle()) {
      @let hasDrivers = !!drivers()?.length;

      <onyx-data-widget
        [showDivider]="hasDrivers"
        [color]="areDriversInvalid() ? 'yellow' : 'gray'"
      >
        <ng-container heading>
          @if (hasDrivers) {
            <div class="heading">
              @for (driver of drivers(); track driver.uuid) {
                <div class="heading-item">
                  <onyx-icon
                    [name]="getDriverIcon(driver)"
                    [size]="20"
                  ></onyx-icon>

                  <app-module-link
                    module="drivers"
                    [color]="null"
                    font="f-heading-m"
                    (linkClick)="openDriverModal(driver)"
                  >
                    {{ driver.driverData | onyxName }}
                  </app-module-link>
                </div>
              }
            </div>
          }
        </ng-container>

        <ng-container description>
          @if (drivers()?.length === 1) {
            <span class="f-body-m">
              {{ `${I18N}.oneDriver` | translate }}
            </span>
          }
        </ng-container>

        <div class="list">
          <p class="f-body-s">
            {{ 'labels.driverRequirements' | translate }}
          </p>

          @for (item of driverParameters(); track item.name) {
            <div class="item">
              @if (hasDrivers) {
                @if (driversLoading()) {
                  <onyx-spinner [size]="20"></onyx-spinner>
                } @else {
                  @if (item.ok()) {
                    <onyx-icon
                      class="check"
                      name="check-circle-filled"
                      [size]="20"
                    ></onyx-icon>
                  } @else {
                    <onyx-icon
                      name="alert-two-tone-filled"
                      [size]="20"
                    ></onyx-icon>
                  }
                }
              } @else {
                <div class="icon"></div>
              }

              <p class="parameter gray">
                <span>
                  {{ item.name | translate }}
                </span>
              </p>
            </div>
          }
        </div>
      </onyx-data-widget>
    }
  </div>
}

<ng-template #trailerTypesTooltipTemplate>
  @let types = this.searchingTrailerTypes() ?? [];
  @if (types.length) {
    <div class="tooltip">
      @for (type of types; track type) {
        <div class="item">
          <span>•</span>

          <span>
            {{ `${DictionaryCode.VEHICLE_TYPE}.${type}` | translate }}
          </span>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template
  let-key="key"
  let-hint="hint"
  let-decimalPlaces="decimalPlaces"
  #hintTemplate
>
  @if (hint) {
    <span class="hint">
      ·
      {{ hint | number: `1.0-${decimalPlaces}` }}
      {{ HINT_UNITS[key] | translate }}
    </span>
  }
</ng-template>

<ng-template
  let-showOnlyInvalid="showOnlyInvalid"
  let-color="color"
  #vehicleParametersTemplate
>
  <div class="list">
    @if (showOnlyInvalid) {
      <p class="f-body-s">
        {{ `${I18N}.notMeetRequirements` | translate }}
      </p>
    } @else if (vehicleParameters().length) {
      <p class="f-body-s">
        @let categories = searchingVehicleData().categories;
        @if (categories.length === 1) {
          @let category = categories[0];
          {{ `${I18N}.requirements.${category}` | translate }}
        } @else {
          {{ 'labels.vehicleRequirements' | translate }}
        }
      </p>
    }

    @for (
      item of showOnlyInvalid
        ? vehicleInvalidParameters()
        : vehicleParameters();
      track item.name
    ) {
      @if (!item.hidden) {
        <div class="item">
          @if (vehicle()) {
            @if (item.ok()) {
              <onyx-icon
                class="check"
                name="check-circle-filled"
                [size]="20"
              ></onyx-icon>
            } @else {
              <onyx-icon name="alert-two-tone-filled" [size]="20"></onyx-icon>
            }
          } @else {
            <div class="icon"></div>
          }

          @let value = $any(item.value);
          <p class="parameter {{ color }}">
            @let isTrue = value === true;
            <span> {{ item.name | translate }}{{ isTrue ? null : ':' }} </span>

            @let key = item.key;
            @if (!isTrue) {
              <span>
                @switch (key) {
                  @case ('adrClasses') {
                    {{
                      value
                        | join
                          : {
                              maxLength: 1,
                              separator: ', ',
                              i18nKey: DictionaryCode.ADR_CLASS,
                            }
                    }}
                  }
                  @case ('temperatureRange') {
                    {{ value | onyxTemperature }}
                  }
                  @case ('minEmissionStandard') {
                    {{
                      `${DictionaryCode.EMISSION_STANDARD}.${value}` | translate
                    }}
                  }
                  @case ('fuelTypes') {
                    {{
                      value
                        | join
                          : {
                              maxLength: 2,
                              i18nKey: DictionaryCode.FUEL_TYPE,
                            }
                    }}
                  }
                  @case ('coilWellLength') {
                    <app-unit-cell
                      [value]="value"
                      unit="m"
                      [decimalPlaces]="2"
                    ></app-unit-cell>
                  }
                  @case ('hooksNumber')
                  @case ('matsNumber')
                  @case ('beltsNumber') {
                    <app-unit-cell
                      [value]="value"
                      [unit]="'units.pieces' | translate"
                    ></app-unit-cell>
                  }
                  @default {
                    {{ value }}
                  }
                }
              </span>
            }

            <ng-container
              *ngTemplateOutlet="
                hintTemplate;
                context: {
                  key: item.key,
                  hint: item.hint,
                  decimalPlaces: item.hintDecimalPlaces,
                }
              "
            ></ng-container>
          </p>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template
  let-showOnlyInvalid="showOnlyInvalid"
  let-color="color"
  #trailerParametersTemplate
>
  <div class="list">
    <p class="f-body-s">
      @if (showOnlyInvalid) {
        {{ `${I18N}.notMeetRequirements` | translate }}
      } @else {
        {{
          `${I18N}.requirements.${searchingVehicleData().isLowDeck ? FleetCategory.SEMI_TRAILER : FleetCategory.TRAILER}`
            | translate
        }}
      }
    </p>

    @for (
      item of showOnlyInvalid
        ? trailerInvalidParameters()
        : trailerParameters();
      track item.name
    ) {
      <div
        class="item"
        [onyxTooltip]="trailerTypesTooltipTemplate"
        [onyxTooltipDisabled]="!item.showTooltip"
      >
        @if (trailer()) {
          @if (item.ok()) {
            <onyx-icon
              class="check"
              name="check-circle-filled"
              [size]="20"
            ></onyx-icon>
          } @else {
            <onyx-icon name="alert-two-tone-filled" [size]="20"></onyx-icon>
          }
        } @else {
          <div class="icon"></div>
        }

        <p class="parameter {{ color }}">
          <span>{{ item.name | translate }}</span>

          <ng-container
            *ngTemplateOutlet="
              hintTemplate;
              context: {
                key: item.key,
                hint: item.hint,
                decimalPlaces: item.hintDecimalPlaces,
              }
            "
          ></ng-container>
        </p>
      </div>
    }
  </div>
</ng-template>
